module.exports = __webpack_public_path__ + "static/media/BRS_BANNER_BLUE.28e762c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/figures/BRS_BANNER_BLUE.jpg
// module id = 649
// module chunks = 0